import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';
import { PromoComponent } from 'src/components/common/modules/v1/promo/code-split/promo-component';
import CpCmsLitePromo from 'src/components/common/modules/v1/promo/promo';

const PromoModule = (props: ModuleProps) => {
  const { id, defaultSetting, data } = props;
  return <PromoComponent key={id} defaultSetting={defaultSetting} data={data} />;
};

const PromoContentModule = (props: ModuleProps) => {
  return <CpCmsLitePromo  {...props}/>
}

export { PromoModule, PromoContentModule };
